import { render, staticRenderFns } from "./TournamentRanking.vue?vue&type=template&id=4478fad2&scoped=true"
import script from "./TournamentRanking.vue?vue&type=script&lang=js"
export * from "./TournamentRanking.vue?vue&type=script&lang=js"
import style0 from "./TournamentRanking.vue?vue&type=style&index=0&id=4478fad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478fad2",
  null
  
)

export default component.exports